import React from 'react';
import { Box, Button } from '@mui/material';

interface StatusButtonProps {
  status: string | string[];
}

export function StatusButton({ status }: StatusButtonProps) {
  const chipStyles: Record<
    string,
    { backgroundColor: string; color: string; hoverBg: string }
  > = {
    PENDING: {
      backgroundColor: '#FFECB3',
      color: '#D57F17',
      hoverBg: '#FDD835',
    },
    APPROVED: {
      backgroundColor: '#DFF0D8',
      color: '#4CAF50',
      hoverBg: '#A5D6A7',
    },
    DENIED: {
      backgroundColor: '#F8D7DA',
      color: '#F44336',
      hoverBg: '#EFA5AC',
    },
    EXPIRED: { backgroundColor: '#C62828', color: 'white', hoverBg: '#B71C1C' },
    ACTIVE: {
      backgroundColor: '#dff6e5',
      color: '#358151',
      hoverBg: '#A5D6A7',
    },
    INACTIVE: {
      backgroundColor: '#f4ecea',
      color: '#e03636',
      hoverBg: '#e0c8c6',
    },
    OTHER: {
      backgroundColor: '#e1f5fe',
      color: '#039be5',
      hoverBg: '#81d4fa',
    },
  };

  const formattedStatuses = Array.isArray(status) ? status : [status];
  return (
    <Box display="flex" flexWrap="wrap" gap="8px">
      {formattedStatuses?.map((s) => {
        const formattedStatus = s?.toUpperCase();
        const styles = chipStyles[formattedStatus] || chipStyles.OTHER;
        return (
          <Button
            key={formattedStatus}
            sx={{
              ...styles,
              fontWeight: 'bold',
              fontSize: {
                xxl: '0.8rem',
                xl: '0.7rem',
                lg: '0.6rem',
                md: '0.6rem',
              },
              border: 'none',
              padding: '0',
              paddingX: {
                xxl: '5px',
                xl: '3px',
                lg: '2px',
                md: '0px',
              },
              textTransform: 'uppercase',
              transition: 'background-color 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: styles?.hoverBg || styles.backgroundColor,
              },
            }}
          >
            {formattedStatus}
          </Button>
        );
      })}
    </Box>
  );
}
